class NumberFormat {
  constructor() {
    this.decimals = {
      "en": ".",
      "es": ".",
      "fr": ".",
      "de": ",",
    };

    this.thousands = {
      "en": ",",
      "es": ",",
      "fr": ",",
      "de": ".",
    };
  }
  
  numberFormat(number, lang) {
    number = parseFloat(number);

    const decimals = this.decimals[lang] || ".";
    const thousands = this.thousands[lang] || ",";

    const formattedNumber = number.toLocaleString(lang, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
      decimal: decimals,
      thousands: thousands
    });

    return formattedNumber;
  }
}

const numberFormatter = new NumberFormat();

export default numberFormatter;

